<script>
export default {
  props: {
    value: null
  }
}
</script>
